import { useRouter } from "next/router";
import { useEffect, useRef } from "react";

export default function ScrollManager() {
  const router = useRouter();
  //objeto com as posições de scroll para cada URL
  const scrollPositions = useRef({});
  // identificar quando o usuário está navegando para trás
  const isBack = useRef(false);

  useEffect(() => {
    // Salva a posição atual do scroll para a URL atual
    const onRouteChangeStart = () => {
      const url = router.asPath;
      scrollPositions.current[url] = window.scrollY;
    };

    // Se isBack for true, restaura a posição do scroll para a URL para a qual estamos navegando
    const onRouteChangeComplete = (url) => {
      if (isBack.current) {
        isBack.current = false;
        window.scrollTo({
          top: scrollPositions.current[url] || 0,
          left: 0,
          behavior: "instant",
        });
      }
    };

    // Detecta quando o usuário está prestes a navegar para trás (usando o botão de voltar do navegador)
    const onBeforePopState = () => {
      isBack.current = true;
      return true;
    };

    router.events.on("routeChangeStart", onRouteChangeStart);
    router.events.on("routeChangeComplete", onRouteChangeComplete);
    router.beforePopState(onBeforePopState);

    if (typeof window !== "undefined") {
      window.history.scrollRestoration = "manual";
    }

    return () => {
      router.events.off("routeChangeStart", onRouteChangeStart);
      router.events.off("routeChangeComplete", onRouteChangeComplete);
      router.beforePopState(() => true);
    };
  }, [router]);

  return null;
}
